import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FunctionSource, FunctionType } from '../../../core/api/models/function.model';
import { FunctionQueueStatus, FunctionTriggerSource } from '../../../core/api/models/function-run.model';

export interface RunFilterValue {
  search: string;
  source: FunctionSource | '';
  functionType: FunctionType | '';
  triggerSource: FunctionTriggerSource | '';
  status: FunctionQueueStatus | '';
  fromDate: string;
  toDate: string;
}

export function emptyRunFilters(): RunFilterValue {
  return {
    search: '',
    source: '',
    functionType: '',
    triggerSource: '',
    status: '',
    fromDate: '',
    toDate: '',
  };
}

@Component({
  selector: 'app-run-filters',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './run-filters.component.html',
  styleUrl: './run-filters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RunFiltersComponent implements OnChanges {
  @Input() value: RunFilterValue = emptyRunFilters();
  @Input() statuses: FunctionQueueStatus[] = [
    'Pending', 'Running', 'Cancelling', 'Retrying', 'Successful', 'Failed', 'Cancelled',
  ];
  @Input() loading = false;
  @Output() readonly filtersChange = new EventEmitter<RunFilterValue>();

  readonly sources: FunctionSource[] = ['Daas', 'AppDirect', 'Webshop', 'ServiceNow'];
  readonly functionTypes: FunctionType[] = ['Delta', 'Full'];
  readonly triggerSources: FunctionTriggerSource[] = ['Scheduled', 'Manual'];
  draft: RunFilterValue = emptyRunFilters();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.draft = { ...this.value };
    }
  }

  apply(): void {
    this.filtersChange.emit({ ...this.draft, search: this.draft.search.trim() });
  }

  clear(): void {
    this.draft = emptyRunFilters();
    this.filtersChange.emit({ ...this.draft });
  }
}
